export default __webpack_public_path__ + "static/media/personal2.8abbea07.jpeg";